export enum ECUSTOMER_STATUS {
  // Old Ones
  PENDING = 'PENDING',
  WITHOUT_SCORE = 'WITHOUT_SCORE',
  AVAILABLE_SCORE = 'AVAILABLE_SCORE',
  TOLERANCE = 'TOLERANCE',
  LOWER_SCORE = 'LOWER_SCORE',
  UNAVAILABLE_SCORE = 'UNAVAILABLE_SCORE',
  SCORE_0 = 'SCORE_0',
  LESS_TRANSACTION = 'LESS_TRANSACTION',
  GREATER_TRANSACTION = 'GREATER_TRANSACTION',
  // New Ones
  ACTIVE = 'active',
  ARCHIVED = 'archived',
  INACTIVE = 'inactive',
  UNSIGNED = 'unsigned',
  UNREGISTERED = 'unregistered',
}

export enum EVALIDATION_STATUS {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  ERROR = 'error',
}

export enum EVALIDATION_COMPLETE {
  BURO = 'buro',
  KEY_NUA = 'key_nua',
  INSPEKTOR = 'inspektor',
}
